import IconNameEnum from "constants/IconNameEnum";
import TipoDocumentoEnum from "constants/TipoDocumentoEnum";
import environment from "environment";
import React from "react";
import { Col, Form, ProgressBar, Row } from "react-bootstrap";
import BaseModal from "../base-content/BaseModal";
import BaseButton from "../base-form/BaseButton";
import BaseIcon from "../base-form/BaseIcon";

interface IProps {
    uploadAction?: (
        file: File,
        fileName: string,
        fileType: string,
        progressHandler: (progress: number) => void
    ) => Promise<void>;
    displayUpload?: boolean;
    displayNameOfFile?: boolean;
    fileSize?: number;
    allowedFormat?: TipoDocumentoEnum;
    className?: string;
    onChange?: (content: File) => void;
    isIE?: boolean;
}
interface IState {
    isChoosing: boolean;
    isUploading: boolean;
    isDownloading: boolean;
    progressUpload: number;
    progressDownload: number;
    showAlertFileNonValido: boolean;
    fileName: string;
    nonValidSize: boolean;
}

class BaseFile extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            isChoosing: false,
            isUploading: false,
            isDownloading: false,
            progressUpload: 0,
            progressDownload: 0,
            showAlertFileNonValido: false,
            fileName: "",
            nonValidSize: false,
        } as IState;
    }

    private hasUnmounted = false;
    private inputFileRef: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>();
    private downloadFileRef: React.RefObject<HTMLAnchorElement> = React.createRef<HTMLAnchorElement>();

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    public downloadFile = (
        action: (progressHandler: (progress: number) => void) => Promise<Blob>,
        filename: string
    ) => {
        if (this.hasUnmounted === false) {
            this.setState({
                isDownloading: true,
            });
        }
        const updateProgress = (progress: number) => {
            if (this.hasUnmounted === false) {
                this.setState({
                    progressDownload: progress,
                });
            }
        };
        action(updateProgress).then((response: Blob) => {
            if (response && response instanceof Blob && this.downloadFileRef.current) {
                this.downloadFileRef.current.href = window.URL.createObjectURL(response);
                this.downloadFileRef.current.download = filename;
                this.downloadFileRef.current.click();
            }
            if (this.hasUnmounted === false) {
                this.setState({
                    isDownloading: false,
                    progressDownload: 0,
                });
            }
        });
    };

    public uploadFile = () => {
        if (this.hasUnmounted === false) {
            this.setState({
                isChoosing: true,
            });
        }
        if (this.inputFileRef.current) {
            this.inputFileRef.current.value = "";
            this.inputFileRef.current.click();
        }
    };

    private uploadFileSelected = async (event: React.ChangeEvent<HTMLInputElement>) => {
        // if (this.props.uploadAction === undefined) {
        //     console.error("uploadAction param is required");
        //     return;
        // }
        if (this.hasUnmounted === false) {
            this.setState({
                isChoosing: false,
            });
        }

        if (event.currentTarget.files && event.currentTarget.files.length > 0) {
            if (this.hasUnmounted === false) {
                this.setState({
                    isUploading: true,
                });
            }
            let file = event.currentTarget.files[0];
            let fileName = event.currentTarget.files[0].name;
            let fileType = fileName.includes(".") ? fileName.substring(fileName.lastIndexOf(".")).toLowerCase() : "";
            let fileSize = event.currentTarget.files[0].size;
            let valid = false;

            this.props.onChange && this.props.onChange(file);

            for (let i = 0; i < environment.uploadFileAcceptedTypes.length; i++) {
                if (fileType.toLowerCase() === this.props.allowedFormat?.toLowerCase()) {
                    valid = true;
                    if (fileSize > this.props.fileSize!) {
                        valid = false;
                        this.setState({ nonValidSize: true });
                    }
                    break;
                } else {
                    if (this.hasUnmounted === false) {
                        this.setState({
                            showAlertFileNonValido: true,
                        });
                    }
                }
            }

            // for (let i = 0; i < environment.uploadFileAcceptedTypes.length; i++) {
            //     const acceptedType = environment.uploadFileAcceptedTypes[i];
            //     if (fileType.toLowerCase() === acceptedType.toLowerCase()) {
            //         valid = true;
            //         break;
            //     }
            // }

            // if (fileSize > environment.uploadFileSizeLimit) {
            //     valid = false;
            // }

            if (valid === false) {
                if (this.hasUnmounted === false) {
                    this.setState({
                        isUploading: false,
                    });
                }
                event.currentTarget.value = "";
                return;
            }

            const updateProgress = (progress: number) => {
                if (this.hasUnmounted === false) {
                    this.setState({
                        progressUpload: progress,
                    });
                }
            };
            // this.props.uploadAction(file, fileName, fileType, updateProgress).then(() => {
            //     if (this.hasUnmounted === false) {
            //         this.setState({
            //             isChoosing: false,
            //             isUploading: false,
            //             isDownloading: false,
            //             progressUpload: 0,
            //             progressDownload: 0,
            //         });
            //     }
            // });

            if (this.hasUnmounted === false) {
                this.setState({
                    isChoosing: false,
                    isUploading: false,
                    isDownloading: false,
                    progressUpload: 0,
                    progressDownload: 0,
                    fileName: fileName,
                });
            }
        }
    };

    private onHideAlertFileNonValido = (): void => {
        if (this.hasUnmounted === false) {
            this.setState({
                showAlertFileNonValido: false,
            });
        }
    };

    private onHideAlertSizeNonValido = (): void => {
        if (this.hasUnmounted === false) {
            this.setState({
                nonValidSize: false,
            });
        }
    };

    public render(): JSX.Element {
        const {
            isUploading,
            isDownloading,
            showAlertFileNonValido,
            progressUpload,
            progressDownload,
            fileName,
        } = this.state;

        const { displayUpload, displayNameOfFile, className, isIE } = this.props;

        return (
            <>
                {displayUpload ? (
                    <Form.File.Label>
                        <BaseIcon
                            onClick={isIE ? () => this.inputFileRef.current?.click() : () => {}}
                            icon={IconNameEnum.Upload}
                            className={`${className}`}
                        />
                        <Form.File
                            ref={this.inputFileRef}
                            hidden
                            className="d-none"
                            accept={this.props.allowedFormat}
                            onChange={this.uploadFileSelected}
                        />
                    </Form.File.Label>
                ) : (
                    <Form.File
                        ref={this.inputFileRef}
                        hidden
                        className="d-none"
                        accept={environment.uploadFileAcceptedTypes.join(", ")}
                        onChange={this.uploadFileSelected}
                    />
                )}

                {displayNameOfFile && <div>{fileName}</div>}

                {
                    // eslint-disable-next-line
                    <a ref={this.downloadFileRef} hidden className="d-none" href="" download=""></a>
                }

                <BaseModal
                    show={this.state.nonValidSize}
                    onHideHandler={this.onHideAlertFileNonValido}
                    closeOnOutClick={true}
                    centered={true}
                    title={"Avviso"}
                    body={"Il documento caricato supera i 5 MB"}
                    footer={
                        <BaseButton
                            type="button"
                            color="grey"
                            label={"Ok"}
                            icon={IconNameEnum.Ok}
                            onClickHandler={this.onHideAlertSizeNonValido}
                        />
                    }
                />

                <BaseModal
                    show={isUploading}
                    closeOnOutClick={false}
                    centered={true}
                    title={"Attendere"}
                    body={
                        <Row>
                            <Col>
                                <Form.Label>{"Upload in corso"}</Form.Label>
                                <ProgressBar
                                    animated
                                    min={0}
                                    max={100}
                                    now={progressUpload}
                                    label={progressUpload + "%"}
                                />
                            </Col>
                        </Row>
                    }
                />

                <BaseModal
                    show={isDownloading}
                    closeOnOutClick={false}
                    centered={true}
                    title={"Attendere"}
                    body={
                        <Row>
                            <Col>
                                <Form.Label>{"Download in corso"}</Form.Label>
                                <ProgressBar
                                    animated
                                    min={0}
                                    max={100}
                                    now={progressDownload}
                                    label={progressDownload + "%"}
                                />
                            </Col>
                        </Row>
                    }
                />

                <BaseModal
                    show={showAlertFileNonValido}
                    onHideHandler={this.onHideAlertFileNonValido}
                    closeOnOutClick={true}
                    centered={true}
                    title={"Avviso"}
                    body={"File non valido"}
                    footer={
                        <BaseButton
                            type="button"
                            color="grey"
                            label={"Ok"}
                            icon={IconNameEnum.Ok}
                            onClickHandler={this.onHideAlertFileNonValido}
                        />
                    }
                />
            </>
        );
    }
}

export { BaseFile as Unconnected };
export default BaseFile;
